import {
  IHttpService
} from './http.service.interface';
import {HttpError} from "./interfaces";


export class HttpService implements IHttpService {
  async get(url: string, options?: RequestInit): Promise<any> {
    const fetchedResponse = await this._fetchResponse(url,'GET', options);
    return this._parseResponse(fetchedResponse);
  }

  async post(url: string, options?: RequestInit): Promise<any> {
    const fetchedResponse = await this._fetchResponse(url, 'POST', options);
    return this._parseResponse(fetchedResponse);
  }

  createUrlSearchParams(): URLSearchParams {
    return new URLSearchParams();
  }

  createHeaders(): Headers {
    return new Headers();
  }

  async _fetchResponse(url: string, method: string, options?: RequestInit):Promise<Response> {
    options = {...options, method: method};
    const response = await fetch(url, options);

    return response;
  }

  async _parseResponse(response: Response):Promise<any> {
    if(!response.ok) {
      throw new HttpError(response);
    }

    const contentTypeHeader = response.headers.get('Content-Type') || '';
    let charset = 'utf-8';
    if(contentTypeHeader.indexOf('charset=') > -1) {
      [,charset] = /charset=([^ ]+)/.exec(contentTypeHeader);
    }

    const blob = await response.blob();
    const text = await this._decodeBlob(blob, charset);

    if(contentTypeHeader.indexOf('application/json') >= 0) {
      return JSON.parse(text);
    } else {
      return text;
    }
  }

  private _decodeBlob(source: Blob, encoding: string = 'utf-16'): Promise<string> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.readAsText(source, encoding);
    })
  }
}
